import { ITranslations } from 'types/common';
import { BrandsCataloguesFiltersFormTransFields } from './types';
import en from 'translations/en/brandsCataloguesFiltersForm.json';
import pl from 'translations/pl/brandsCataloguesFiltersForm.json';
import sl from 'translations/sl/brandsCataloguesFiltersForm.json';

export const brandsCataloguesFiltersFormTranslations: ITranslations<BrandsCataloguesFiltersFormTransFields> = {
  name: 'brandsCataloguesFiltersForm',
  en,
  pl,
  sl,
};
